/**
 * Stable compact int codes for shipment track delta series
 * (mirror of gpx-device-api FixTypeCompactCode).
 */
export const FIX_TYPE_COMPACT = {
  UNKNOWN: 0,
  GPS: 1,
  WIFI: 2,
  CELL: 3,
  BLE: 4,
  ANCHOR: 5,
} as const;

export type FixTypeCompactCode =
  (typeof FIX_TYPE_COMPACT)[keyof typeof FIX_TYPE_COMPACT];

const LABEL_BY_CODE: Record<number, string> = {
  [FIX_TYPE_COMPACT.UNKNOWN]: 'Unknown',
  [FIX_TYPE_COMPACT.GPS]: 'GPS',
  [FIX_TYPE_COMPACT.WIFI]: 'Wi-Fi',
  [FIX_TYPE_COMPACT.CELL]: 'Cell',
  [FIX_TYPE_COMPACT.BLE]: 'BLE',
  [FIX_TYPE_COMPACT.ANCHOR]: 'Anchor',
};

export function fixTypeLabelFromCompactCode(code: number): string {
  return LABEL_BY_CODE[code] ?? LABEL_BY_CODE[FIX_TYPE_COMPACT.UNKNOWN]!;
}

/**
 * Map v2 current-positions `fix` string (e.g. "gps", "wifi", "cell")
 * to the same compact codes used by track delta series.
 */
export function fixTypeCompactCodeFromLabel(
  fix: string | null | undefined,
): FixTypeCompactCode {
  if (fix == null) return FIX_TYPE_COMPACT.UNKNOWN;
  const key = String(fix).trim().toLowerCase().replace(/[\s_-]+/g, '');
  switch (key) {
    case 'gps':
    case 'gnss':
      return FIX_TYPE_COMPACT.GPS;
    case 'wifi':
      return FIX_TYPE_COMPACT.WIFI;
    case 'cell':
    case 'cellular':
      return FIX_TYPE_COMPACT.CELL;
    case 'ble':
    case 'bluetooth':
      return FIX_TYPE_COMPACT.BLE;
    case 'anchor':
      return FIX_TYPE_COMPACT.ANCHOR;
    default:
      return FIX_TYPE_COMPACT.UNKNOWN;
  }
}
